import type { KYCQuestionDefinition } from '@anchorage/graphql/generated';
import { FormRadioButtonGroup, reactHookForm } from '@latitude/form';
import type { FC } from 'react';
import { useMemo } from 'react';

import css from './styles.module.css';

type Props = {
  question: KYCQuestionDefinition;
  isDisabled?: boolean;
};

const RadioGroupComponent: FC<Props> = ({ question, isDisabled = false }) => {
  const { control } = reactHookForm.useFormContext();

  const options = useMemo(
    () =>
      question.options?.map((opt) => ({
        value: opt.id,
        label: opt.text,
        disabled: isDisabled,
      })),
    [question, isDisabled],
  );

  return (
    <div className={css.radioGroup}>
      <FormRadioButtonGroup
        control={control}
        name={`${question.id}.options`}
        options={options ?? []}
      />
    </div>
  );
};

export { RadioGroupComponent };
